import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam'; // post请求体转换方法

const serverUrl = publishObjectPath.serverUrl;
const qs = require('qs');
const conttype = 'application/x-www-form-urlencoded';

export class DemoServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 自定义返回方法
  public getDemoData() {
    return new Promise((resolve, reject) => {
      const list: any = [];
      for (let i = 0; i < 10; i++) {
        list.push({
          id: `id${i}`,
          longitude: 116 + Math.random(),
          latitude: 39 + Math.random(),
        });
      }
      resolve(list);
    });
  }

  // 请求体get请求
  public demo1(opts: object) {
    const url = serverUrl + '/api/sysMenu';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 拼接get请求
  public demo2(id: string) {
    const url = serverUrl + '/big-screen/event/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 无参get请求
  public demo3() {
    const url = serverUrl + '/big-screen/listing-hazard/listing-supervise-supervise';
    return this.rSerivce.serverObj.get(url);
  }

  // post请求
  public demo4(opts?: object) {
    const url = serverUrl + '/credit-ent-blacklist/batch';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // post请求拼接
  public demo5(opts: object) {
    const url = serverUrl + '/api/apiName' + changePostParam(opts);
    return this.rSerivce.serverObj.post(url);
  }
}
